import styled from "@emotion/styled";
import { MarkdownSyntaxHighlighter } from "@features/Chat/components/MarkdownSyntaxHighlighter";
import { Tooltip, Typography } from "@mui/material";
import { format, formatDistanceToNow } from "date-fns";
import {
  getAuthorName,
  getFormattedAction,
  getFormattedMessageText,
} from "./user-logs-helpers";

type Props = {
  id: string;
  data: any;
  createdAt: Date;
  action: string;
  userName?: string;
  createdBy: string;
  highlight: boolean;
};

const UserLogContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 1rem;
  padding: 1rem;
  background-color: ${(p) => p.theme.colors.background};
  opacity: 0.4;
  &.user-log-highlighted {
    opacity: 1;
  }
`;

const ContentContainer = styled.div`
  margin: 0 !important;

  pre {
    margin: 0 !important;
    overflow: hidden;

    & > div {
      max-width: 100% !important;
      border-radius: 0.5rem !important;
      font-size: ${(p) => p.theme.text.fontSizes.m} !important;
      overflow-x: auto !important;
      margin: 0 !important;
      padding: 1.5rem !important;
      max-height: 400px !important;

      * {
        white-space: pre-wrap;
        word-break: break-word;
      }
    }
  }
`;

export const UserLog = (props: Props) => {
  const { data, action, createdBy, userName, createdAt, highlight } = props;

  return (
    <UserLogContainer
      className={highlight ? "user-log-highlighted" : undefined}
      data-isartifact={/\(artifact\)/.test(action)}
    >
      <Typography display={"flex"} justifyContent={"space-between"}>
        <Typography component={"span"} fontWeight={"bold"}>
          {getAuthorName({ createdBy, userName })} -{" "}
          <Typography component={"span"}>
            {getFormattedAction(action)}
          </Typography>
        </Typography>
        <Tooltip
          title={formatDistanceToNow(new Date(createdAt), { addSuffix: true })}
        >
          <Typography component={"span"} variant="body2">
            {format(new Date(createdAt), "MM/dd/yyyy hh:mm:ss a")}
          </Typography>
        </Tooltip>
      </Typography>
      <ContentContainer>
        <MarkdownSyntaxHighlighter text={getFormattedMessageText(data)} />
      </ContentContainer>
    </UserLogContainer>
  );
};
